export default __webpack_public_path__ + "static/media/Payment.4d56af67.graphql";